import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import Header from './components/header/Header';
import Home from './components/mainpage/Home';
import DeleteUser from './components/deleteUser/DeleteUser';
import Footer from './components/footers/Footer';
import Privacypolicy from './components/policyPages/Privacypolicy';
import Terms from './components/policyPages/Terms';

function App() {
  return (
    <BrowserRouter basename='/'>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/deleteUser" element={<DeleteUser />} />
        <Route path="/privacy-policy" element={<Privacypolicy />} />
        <Route path="/terms" element={<Terms />} />
      </Routes>
      <Footer />
  </BrowserRouter> 
  );
}

export default App;
